export const getClassesForSyndicateMemberName = (role: string, member: string): string[] => {
  const isLead = role === 'Syndicate Lead';
  const isBofa = member.toLowerCase().includes('bofa');
  const classes = [];
  if (isLead) classes.push('syndicate-lead-member');
  if (isBofa) classes.push('bofa-member');
  return classes;
};
